module.exports = __webpack_public_path__ + "img/1319.7c52a1e6.gif";